export default {
  user: {},
  info: {
    ready: false,
    configs: {}
  }
};
